import { SidePanelProgressBar } from "@nova/component-side-panel-tab-container"
import { TimeElapsed } from "@nova/component-time-elapsed"

export const UploadProgressBar = ({
    progress,
    total,
    timeElapsed,
}: {
    progress: number
    total: number
    timeElapsed?: number | string
}) => {
    const date = timeElapsed && new Date(timeElapsed)
    return (
        <div className="my-4">
            <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-1">
                    {progress > 0 ? (
                        <h5 className="text-gray-0">Uploading:</h5>
                    ) : (
                        <h5 className="text-gray-0">Upload Queued</h5>
                    )}
                    {progress > 0 && (
                        <h5 className="text-gray-100">{`${Math.round((progress / total) * 100)}%`}</h5>
                    )}
                </div>
                {date && <TimeElapsed start={date} className="text-[14px] text-gray-100" />}
            </div>
            <SidePanelProgressBar progress={progress} total={total} colorHex={"#16C949"} />
        </div>
    )
}

export const ProgressBar = ({
    progress,
    total,
    timeElapsed,
}: {
    progress: number
    total: number
    timeElapsed?: number | string
}) => {
    const date = timeElapsed && new Date(timeElapsed)
    return (
        <div className="my-4">
            <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-1">
                    <h5 className="text-gray-0">Processing:</h5>
                    <h5 className="text-gray-100">{`${Math.round((progress / total) * 100)}%`}</h5>
                </div>
                {date && <TimeElapsed start={date} className="text-[14px] text-gray-100" />}
            </div>
            <SidePanelProgressBar progress={progress} total={total} colorHex={"#27BBFF"} />
        </div>
    )
}
